(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldDropdownQn', fbFieldDropdownQnDirective);

    const defaultTemplateUrl = 'common/app/components/form/question-set/column/dropdown';

    function fbFieldDropdownQnDirective($templateCache, lodash, $timeout) {
        return {
            restrict: 'EA',
            scope: {
                element: '=',
                model: '='
            },
            template: function(elem, attr) {
                console.log(arguments);
                var templateUrl = lodash.get(attr, 'template', '');
                if (lodash.isEmpty(templateUrl)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                var template = $templateCache.get(templateUrl);
                if (lodash.isEmpty(template)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                return template;
            },
            bindToController: true,
            controllerAs: 'vm',
            controller: fbFieldDropdownQnDirectiveCtrl,
            link: function (scope, elem) {
                var vm = scope.vm;
                $timeout(function () {
                    var trigger_change = lodash.get(vm.element, 'options.trigger_change_on_load', false);
                    if (trigger_change) {
                        vm.onEventTrigger('onChange');
                    }
                    // elem.find('.selectize-input input').attr('readonly','readonly');;
                });
            }
        };
    }

    function fbFieldDropdownQnDirectiveCtrl(lodash, FormBuilderService, FbSelectService, $scope, $timeout, GenericModel, $element) {
        var vm = this;
        var formIdentifier = '';
        this.$onInit = function() {
            formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
            vm.element.refreshData = loadRemoteData;

            // preparing additionalOptionss
            vm.additionalOptions = {};

            FbSelectService.initTemplateCall(vm.element.options, vm.additionalOptions);

            if (lodash.has(vm.element, 'options.settings.datasource.data')) {
                vm.ds = angular.copy(lodash.get(vm.element, 'options.settings.datasource.data', null));
                $scope.$watch(function () {
                    return vm.element.options.datasource.data;
                }, function () {
                    if (vm.firstLoad) {
                        $timeout(function () {
                            vm.firstLoad = false;
                        })
                    } else {
                        $timeout(function () {
                            vm.isLoading = true;
                            vm.ds = angular.copy(lodash.get(vm.element, 'options.settings.datasource.data', null));
                            $timeout(function () {
                                vm.isLoading = false;
                            }, 800);
                        });
                    }

                });
            }
            //
            // if (lodash.has(vm.element, 'options.datasource.optgroup_data')) {
            //     vm.additionalOptions.optgroups = vm.element.options.datasource.optgroup_data;
            // }

            vm.firstLoad = true;
            vm.selectizeMsg = '';

            vm.config =
                angular.merge(
                    {
                        highlight: true,
                        create: false,
                        labelField: 'label',
                        valueField: 'value',
                        maxItems: 1,
                        searchField: ['label'],
                        plugins: ['remove_button'],
                        // dropdownParent: 'body',
                        // dropdownClass: 'selectize-dropdown modal-z-index',
                        // placeholder: '',
                        onChange: function () {
                            vm.onEventTrigger('onChange');
                        },
                        onBlur: function () {
                            vm.onEventTrigger('onBlur');
                        },
                        onInitialize: function (selectize) {
                            vm.selectize = selectize;
                            loadRemoteData();
                            $timeout(function () {
                                if (vm.element.attr.disable || vm.pageData.fbData.settings.view_only) {
                                    vm.selectize.disable();
                                }
                            });
                        },
                    },
                    lodash.get(vm.element, 'options.settings.selectize', {}),
                    vm.additionalOptions
                );
        }


        function loadRemoteData() {
            if (lodash.has(vm.element, 'options.settings.datasource.url')) {
                vm.isLoading = true;
                var callRemoteApiPromise = callRemoteApi();
                callRemoteApiPromise.then(function (res) {
                    vm.isLoading = false;
                    var msg = lodash.get(res, 'error_msg');

                    if (msg || res.length === 0) {
                        vm.selectizeMsg = msg;
                        return vm.selectize.disable();
                    }
                    vm.ds = res;
                });
            }
        }

        function callRemoteApi() {
            var model = new GenericModel(vm.element.options.settings.datasource.url);
            var method = lodash.get(vm.element.options.settings.datasource, 'method', 'get');
            return model[method]({}, {data: FormBuilderService.getModel(formIdentifier)}).$promise.then(function (res) { //res
                if (res.success && res.status_code == 200) {
                    return res.data;
                } else {
                    console.warn('Calling ' + vm.element.options.settings.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    return null;
                }
            }, function (res) {
                console.warn('Calling ' + vm.element.options.settings.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }
    }
})();